
import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar";
import TopNav from "../../Components/TopNav";
import {
  getCategoryServ,
  addCategoryServ,
  deleteCategoryServ,
  updateCategoryServ,
} from "../../services/category.service";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import NoRecordFound from "../../Components/NoRecordFound";
import Modal from "react-bootstrap/Modal";
import { getProductsByCategoryServ } from "../../services/product.services";
import { IMAGE_BASE_URL } from "../../utils/api_base_url_configration";


function CategoriesList() {

   const getImageUrl = (image) => {
    if (!image) return "";
    if (image.startsWith("http")) return image;
    return `${IMAGE_BASE_URL}${image}`;
  };

  const getPreviewImage = (img) => {
    if (!img) return "";
    if (img.startsWith("blob:")) return img;
    return getImageUrl(img);
  };

  const [list, setList]       = useState([]);
  const [statics, setStatics] = useState(null);
  const [payload, setPayload] = useState({
    searchKey: "",
    status: "",
    pageNo: 1,
    pageCount: 10,
    sortByField: "position",
    sortByOrder: "asc",
  });
  const [showSkelton, setShowSkelton] = useState(false);

  const handleGetCategoryFunc = async () => {
    if (list.length === 0) setShowSkelton(true);
    try {
      let response = await getCategoryServ(payload);
      setList(response?.data?.data);
      setStatics(response?.data?.documentCount);
    } catch (error) {}
    setShowSkelton(false);
  };

  const staticsArr = [
    { title: "Total Category",    count: statics?.totalCount,    icon: "ti-layout-grid" },
    { title: "Active Category",   count: statics?.activeCount,   icon: "ti-circle-check" },
    { title: "Inactive Category", count: statics?.inactiveCount, icon: "ti-circle-x"     },
  ];

  useEffect(() => { handleGetCategoryFunc(); }, [payload]);

  const [isLoading, setIsLoading] = useState(false);

  /* ── Add ── */
  const [addFormData, setAddFormData] = useState({
    name: "", image: "", status: "", show: false,
    imgPrev: "", specialApperence: "", position: "",
  });

  const handleAddCategoryFunc = async () => {
    setIsLoading(true);
    const formData = new FormData();
    if (addFormData.image) formData.append("image", addFormData?.image);
    formData.append("name",             addFormData?.name);
    formData.append("status",           addFormData?.status);
    formData.append("specialApperence", addFormData?.specialApperence);
    if (addFormData.position !== "") formData.append("position", Number(addFormData.position));
    try {
      let response = await addCategoryServ(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setAddFormData({ name: "", image: "", status: "", position: "", show: false, imgPrev: "" });
        handleGetCategoryFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  /* ── Delete ── */
  const handleDeleteCategoryFunc = async (id) => {
    const confirmed = window.confirm("Are you sure you want to delete this category?");
    if (confirmed) {
      try {
        let response = await deleteCategoryServ(id);
        if (response?.data?.statusCode === "200") {
          toast.success(response?.data?.message);
          handleGetCategoryFunc();
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || "Internal Server Error");
      }
    }
  };

  /* ── Edit ── */
  const [editFormData, setEditFormData] = useState({
    name: "", image: "", status: "", _id: "",
    imgPrev: "", specialApperence: "", position: "",
  });

  const handleUpdateCategoryFunc = async () => {
    setIsLoading(true);
    const formData = new FormData();
    if (editFormData?.image) formData?.append("image", editFormData?.image);
    formData?.append("name",             editFormData?.name);
    formData?.append("status",           editFormData?.status);
    formData?.append("_id",              editFormData?._id);
    formData?.append("specialApperence", editFormData?.specialApperence);
    if (editFormData.position !== "") formData.append("position", Number(editFormData.position));
    try {
      let response = await updateCategoryServ(formData);
      if (response?.data?.statusCode == "200") {
        toast.success(response?.data?.message);
        setEditFormData({ name: "", image: "", status: "", position: "", _id: "" });
        handleGetCategoryFunc();
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || "Internal Server Error");
    }
    setIsLoading(false);
  };

  /* ── View Products Modal ── */
  const [showModal, setShowModal]               = useState(false);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [productsByCategory, setProductsByCategory] = useState([]);

  const handleViewProducts = async (category) => {
    try {
      setSelectedCategory(category);
      const res = await getProductsByCategoryServ(category._id);
      setProductsByCategory(res?.data?.data || []);
      setShowModal(true);
    } catch (error) {
      toast.error("Failed to fetch products.");
    }
  };

  /* ── Pagination ── */
  const [totalPages, setTotalPages] = useState(1);
  useEffect(() => {
    if (statics?.totalCount && payload.pageCount)
      setTotalPages(Math.ceil(statics.totalCount / payload.pageCount));
  }, [statics, payload.pageCount]);

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages)
      setPayload({ ...payload, pageNo: newPage });
  };

  const addValid  = addFormData.name && addFormData.status;
  const editValid = editFormData.name && editFormData.status;

  return (
    <div className="bodyContainer">
      <Sidebar selectedMenu="Product Management" selectedItem="Categories" />

      <div className="mainContainer">
        <TopNav pageTitle="Categories" pagePath="Home / Product Management / Categories" />

        <div className="pl-root">

          {/* ── Stat Cards ── */}
          <div className="pl-stat-grid">
            {staticsArr.map((v, i) => (
              <div className="pl-stat-card" key={i}>
                <div className="pl-stat-icon">
                  <i className={`ti ${v.icon}`} aria-hidden="true" />
                </div>
                <div>
                  <div className="pl-stat-val">{v.count ?? "—"}</div>
                  <div className="pl-stat-lbl">{v.title}</div>
                </div>
              </div>
            ))}
          </div>

          {/* ── Toolbar ── */}
          <div className="pl-toolbar">
            <span className="pl-toolbar-title">Categories</span>

            <input
              className="pl-input"
              placeholder="Search categories..."
              onChange={(e) => setPayload({ ...payload, searchKey: e.target.value })}
            />

            <select
              className="pl-select"
              onChange={(e) => setPayload({ ...payload, status: e.target.value })}
            >
              <option value="">All Status</option>
              <option value={true}>Active</option>
              <option value={false}>Inactive</option>
            </select>

            <button
              className="pl-btn pl-btn-red"
              onClick={() => setAddFormData({ ...addFormData, show: true })}
            >
              <i className="ti ti-plus" aria-hidden="true" />
              Add Category
            </button>
          </div>

          {/* ── Table ── */}
          <div className="pl-table-wrap">
            <div className="pl-table-scroll">
              <table className="pl-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Category Name</th>
                    <th>Status</th>
                    <th>Position</th>
                    <th>Special Apperence</th>
                    <th>Created At</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showSkelton ? (
                    [...Array(8)].map((_, i) => (
                      <tr key={i}>
                        {[...Array(8)].map((__, j) => (
                          <td key={j} className="pl-skel-cell"><Skeleton height={18} /></td>
                        ))}
                      </tr>
                    ))
                  ) : list?.length === 0 ? (
                    <tr>
                      <td colSpan="8" style={{ textAlign: "center", padding: "48px" }}>
                        <NoRecordFound />
                      </td>
                    </tr>
                  ) : (
                    list.map((v, i) => (
                      <tr key={v._id}>

                        {/* # */}
                        <td>
                          <span className="pl-sr">
                            {(payload.pageNo - 1) * payload.pageCount + i + 1}
                          </span>
                        </td>

                        {/* Image */}
                        <td>
                          <img
                             src={getImageUrl(v?.image)}
                            alt={v?.name}
                            className="pl-prod-img"
                            style={{ width: 44, height: 44, borderRadius: 10 }}
                          />
                        </td>

                        {/* Name */}
                        <td>
                          <div className="pl-prod-cell">
                            <span className="pl-prod-name">{v?.name}</span>
                          </div>
                        </td>

                        {/* Status */}
                        <td>
                          <span className={`pl-badge ${v?.status ? "active" : "inactive"}`}>
                            <i
                              className={`ti ${v?.status ? "ti-circle-check" : "ti-circle-x"}`}
                              style={{ fontSize: "13px" }}
                              aria-hidden="true"
                            />
                            {v?.status ? "Active" : "Inactive"}
                          </span>
                        </td>

                        {/* Position */}
                        <td>
                          <span
                            style={{
                              display: "inline-block",
                              background: "#f5f5f7",
                              borderRadius: 7,
                              padding: "3px 12px",
                              fontSize: 13,
                              fontWeight: 600,
                              color: "#555",
                              fontFamily: "monospace",
                            }}
                          >
                            {typeof v?.position === "number" ? v.position : "—"}
                          </span>
                        </td>

                        {/* Special Apperence */}
                        <td>
                          {v?.specialApperence ? (
                            <span className="pl-cat-chip">{v.specialApperence}</span>
                          ) : (
                            <span style={{ color: "#bbb", fontSize: 13 }}>None</span>
                          )}
                        </td>

                        {/* Created At */}
                        <td style={{ color: "#888", fontSize: 13 }}>
                          {moment(v?.createdAt).format("DD MMM YYYY")}
                        </td>

                        {/* Actions */}
                        <td>
                          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                            <button
                              className="pl-view-btn"
                              onClick={() =>
                                setEditFormData({
                                  name:             v?.name,
                                  image:            "",
                                  imgPrev:          v?.image,
                                  status:           v?.status,
                                  _id:              v?._id,
                                  specialApperence: v?.specialApperence,
                                  position:         typeof v?.position === "number" ? v.position : "",
                                })
                              }
                            >
                              <i className="ti ti-pencil" aria-hidden="true" />
                              Edit
                            </button>

                            <button
                              className="pl-btn pl-btn-danger"
                              style={{ height: 34, padding: "0 14px", fontSize: 14 }}
                              onClick={() => handleDeleteCategoryFunc(v?._id)}
                            >
                              <i className="ti ti-trash" aria-hidden="true" />
                              Delete
                            </button>

                            <button
                              className="pl-view-btn"
                              style={{ color: "#2980b9", borderColor: "#d0e8f8" }}
                              onClick={() => handleViewProducts(v)}
                            >
                              <i className="ti ti-eye" aria-hidden="true" />
                              Products
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* ── Pagination ── */}
            <div className="pl-pagination">
              <div className="pl-show-row">
                Show
                <select
                  className="pl-select"
                  style={{ height: 36, padding: "0 10px" }}
                  value={payload.pageCount}
                  onChange={(e) =>
                    setPayload({ ...payload, pageCount: parseInt(e.target.value), pageNo: 1 })
                  }
                >
                  {[10, 25, 50, 100].map((v) => (
                    <option key={v} value={v}>{v}</option>
                  ))}
                </select>
                entries
              </div>

              <div className="pl-page-btns">
                <button
                  className="pl-pg-btn"
                  disabled={payload.pageNo === 1}
                  onClick={() => handlePageChange(payload.pageNo - 1)}
                >
                  <i className="ti ti-chevron-left" style={{ fontSize: 13 }} />
                </button>

                {[...Array(totalPages)].map((_, i) => {
                  const page = i + 1;
                  if (
                    page === 1 || page === totalPages ||
                    (page >= payload.pageNo - 1 && page <= payload.pageNo + 1)
                  ) {
                    return (
                      <button
                        key={page}
                        className={`pl-pg-btn ${payload.pageNo === page ? "active" : ""}`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page}
                      </button>
                    );
                  } else if (
                    (page === payload.pageNo - 2 && page > 2) ||
                    (page === payload.pageNo + 2 && page < totalPages - 1)
                  ) {
                    return <button key={page} className="pl-pg-btn" disabled>...</button>;
                  }
                  return null;
                })}

                <button
                  className="pl-pg-btn"
                  disabled={payload.pageNo === totalPages}
                  onClick={() => handlePageChange(payload.pageNo + 1)}
                >
                  <i className="ti ti-chevron-right" style={{ fontSize: 13 }} />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════
          ADD CATEGORY MODAL
      ══════════════════════════════════════ */}
      {addFormData?.show && (
        <div className="pl-modal-overlay">
          <div className="pl-modal">
            <div className="pl-modal-header">
              <span className="pl-modal-title">Add Category</span>
              <button
                className="pl-modal-close"
                onClick={() =>
                  setAddFormData({ name: "", image: "", status: "", show: false, specialApperence: "", position: "" })
                }
              >
                <i className="ti ti-x" aria-hidden="true" />
              </button>
            </div>

            <div className="pl-modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              {/* Image preview */}
              <div
                style={{
                  width: "100%", height: 140, borderRadius: 10,
                  border: "1px solid #f0eded", background: "#f9f9f9",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  marginBottom: 16, overflow: "hidden",
                }}
              >
                {addFormData?.imgPrev ? (
                 <img src={getPreviewImage(addFormData.imgPrev)} alt="preview"
                    style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                ) : (
                  <span style={{ color: "#bbb", fontSize: 13 }}>No image selected</span>
                )}
              </div>

              <label className="pl-field-label">Upload Image</label>
              <input
                className="pl-field-input" type="file"
                onChange={(e) =>
                  setAddFormData({ ...addFormData, image: e.target.files[0], imgPrev: URL.createObjectURL(e.target.files[0]) })
                }
              />

              <label className="pl-field-label">Name</label>
              <input
                className="pl-field-input" type="text" placeholder="Category name"
                onChange={(e) => setAddFormData({ ...addFormData, name: e.target.value })}
              />

              <label className="pl-field-label">Position</label>
              <input
                className="pl-field-input" type="number" min="0"
                placeholder="Display position"
                value={addFormData.position}
                onChange={(e) =>
                  setAddFormData({ ...addFormData, position: e.target.value.replace(/[^\d]/g, "") })
                }
              />

              <label className="pl-field-label">Status</label>
              <select
                className="pl-field-input" style={{ cursor: "pointer" }}
                onChange={(e) => setAddFormData({ ...addFormData, status: e.target.value })}
              >
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>

              <label className="pl-field-label">Special Apperence</label>
              <select
                className="pl-field-input" style={{ cursor: "pointer" }}
                value={addFormData?.specialApperence}
                onChange={(e) => setAddFormData({ ...addFormData, specialApperence: e.target.value })}
              >
                <option value="">None</option>
                <option value="Home">Home</option>
              </select>
            </div>

            <div className="pl-modal-footer">
              <button
                className="pl-btn"
                style={{ background: "#f0f0f0", color: "#555", height: 40 }}
                onClick={() =>
                  setAddFormData({ name: "", image: "", status: "", show: false, specialApperence: "", position: "" })
                }
              >
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                style={{ height: 40, opacity: addValid && !isLoading ? 1 : 0.5 }}
                disabled={!addValid || isLoading}
                onClick={addValid && !isLoading ? handleAddCategoryFunc : undefined}
              >
                {isLoading ? "Saving..." : "Save Category"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════
          EDIT CATEGORY MODAL
      ══════════════════════════════════════ */}
      {editFormData?._id && (
        <div className="pl-modal-overlay">
          <div className="pl-modal">
            <div className="pl-modal-header">
              <span className="pl-modal-title">Update Category</span>
              <button
                className="pl-modal-close"
                onClick={() =>
                  setEditFormData({ name: "", image: "", status: "", specialApperence: "", position: "", _id: "" })
                }
              >
                <i className="ti ti-x" aria-hidden="true" />
              </button>
            </div>

            <div className="pl-modal-body" style={{ maxHeight: "70vh", overflowY: "auto" }}>
              {/* Image preview */}
              <div
                style={{
                  width: "100%", height: 140, borderRadius: 10,
                  border: "1px solid #f0eded", background: "#f9f9f9",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  marginBottom: 16, overflow: "hidden",
                }}
              >
                {editFormData?.imgPrev ? (
                <img src={getPreviewImage(editFormData.imgPrev)} alt="preview"
                    style={{ width: "100%", height: "100%", objectFit: "contain" }} />
                ) : (
                  <span style={{ color: "#bbb", fontSize: 13 }}>No image</span>
                )}
              </div>

              <label className="pl-field-label">Upload Image</label>
              <input
                className="pl-field-input" type="file"
                onChange={(e) =>
                  setEditFormData({ ...editFormData, image: e.target.files[0], imgPrev: URL.createObjectURL(e.target.files[0]) })
                }
              />

              <label className="pl-field-label">Name</label>
              <input
                className="pl-field-input" type="text"
                value={editFormData?.name}
                onChange={(e) => setEditFormData({ ...editFormData, name: e.target.value })}
              />

              <label className="pl-field-label">Position</label>
              <input
                className="pl-field-input" type="number" min="0"
                value={editFormData.position}
                onChange={(e) =>
                  setEditFormData({ ...editFormData, position: e.target.value.replace(/[^\d]/g, "") })
                }
              />

              <label className="pl-field-label">Status</label>
              <select
                className="pl-field-input" style={{ cursor: "pointer" }}
                value={editFormData?.status}
                onChange={(e) => setEditFormData({ ...editFormData, status: e.target.value })}
              >
                <option value="">Select Status</option>
                <option value={true}>Active</option>
                <option value={false}>Inactive</option>
              </select>

              <label className="pl-field-label">Special Apperence</label>
              <select
                className="pl-field-input" style={{ cursor: "pointer" }}
                value={editFormData?.specialApperence}
                onChange={(e) => setEditFormData({ ...editFormData, specialApperence: e.target.value })}
              >
                <option value="">None</option>
                <option value="Home">Home</option>
              </select>
            </div>

            <div className="pl-modal-footer">
              <button
                className="pl-btn"
                style={{ background: "#f0f0f0", color: "#555", height: 40 }}
                onClick={() =>
                  setEditFormData({ name: "", image: "", status: "", _id: "" })
                }
              >
                Cancel
              </button>
              <button
                className="pl-btn pl-btn-red"
                style={{ height: 40, opacity: editValid && !isLoading ? 1 : 0.5 }}
                disabled={!editValid || isLoading}
                onClick={editValid && !isLoading ? handleUpdateCategoryFunc : undefined}
              >
                {isLoading ? "Saving..." : "Update Category"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ══════════════════════════════════════
          VIEW PRODUCTS MODAL (Bootstrap Modal — logic unchanged)
      ══════════════════════════════════════ */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header
          closeButton
          style={{ borderBottom: "1px solid #f0eded", padding: "18px 24px" }}
        >
          <Modal.Title style={{ fontSize: 17, fontWeight: 700, color: "#1c0a0a" }}>
            Products under{" "}
            <span style={{ color: "#a60808" }}>{selectedCategory?.name}</span>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ padding: "20px 24px" }}>
          {productsByCategory.length > 0 ? (
            <div style={{ overflowX: "auto" }}>
              <table className="pl-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Price</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  {productsByCategory.map((product, index) => (
                    <tr key={product._id}>
                      <td><span className="pl-sr">{index + 1}</span></td>

                      <td>
                        <img
                           src={getImageUrl(product.productHeroImage)}
                          alt={product.name}
                          className="pl-prod-img"
                          style={{ width: 44, height: 44, borderRadius: 10 }}
                        />
                      </td>

                      <td>
                        <span style={{ fontWeight: 600, color: "#1c0a0a", fontSize: 14 }}>
                          {product.name}
                        </span>
                      </td>

                      <td>
                        {product.price ? (
                          <div>
                            <div className="pl-price-main" style={{ color: "#27ae60" }}>
                              Rs {product.discountedPrice}
                            </div>
                            <div className="pl-price-strike">Rs {product.price}</div>
                          </div>
                        ) : (
                          <div className="pl-price-main">Rs {product.price}</div>
                        )}
                      </td>

                      <td>
                        <span className={`pl-badge ${product.status ? "active" : "inactive"}`}>
                          <i
                            className={`ti ${product.status ? "ti-circle-check" : "ti-circle-x"}`}
                            style={{ fontSize: 12 }}
                            aria-hidden="true"
                          />
                          {product.status ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div
              style={{
                textAlign: "center", padding: "40px 0",
                color: "#bbb", fontSize: 14,
              }}
            >
              <i className="ti ti-package-off" style={{ fontSize: 40, display: "block", marginBottom: 12 }} />
              No products found for this category.
            </div>
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default CategoriesList;